class ViewContainer {
  constructor(elementId, html) {
    this._containerId = elementId;
    this._innerHTML = html;
    this._isHidden = false;
    this._prepareContainer(elementId);
    this._createComponent(html);
  }

  get hidden() {
    return this._isHidden;
  }

  set hidden(flag) {
    this._isHidden = flag;
  }

  reCreateComponent() {
    this._prepareContainer(this._containerId);
    this._createComponent(this._innerHTML);
  }

  getContainerElement() {
    "use strict";
    const query = `div#${this._containerId}`;
    return document.querySelector(query);
  };

  hide() {
    this._hideContainer();
  };

  show() {
    this._displayContainer();
  };

  terminate() {
    this._terminateContainer();
  };

  _prepareContainer(elementId) {
    const field = document.createElement('div');
    field.id = elementId;
    field.style.position = 'absolute';
    field.style.left = '0';
    field.style.top = '0';
    field.style.right = '0';
    field.style.bottom = '0';
    field.style.width = '100%';
    field.style.height = '100%';
    field.style.zIndex = "0";
    field.style.display = "none";
    document.body.appendChild(field);
    Graphics._centerElement(field);
    return field;
  }

  _createComponent(html) {
    "use strict";
    const field = this.getContainerElement();
    field.innerHTML = html;
  };

  _displayContainer() {
    const field = this.getContainerElement();
    field.style.zIndex = "1000";
    field.style.display = "block";
    this.hidden = false;
  }

  _hideContainer() {
    const field = this.getContainerElement();
    field.style.zIndex = "0";
    field.style.display = "none";
    this.hidden = true;
  }


  _terminateContainer() {
    const containerElement = this.getContainerElement();
    if(containerElement) {
      document.body.removeChild(containerElement);
    }
  };
}

class IMEDeleteButton extends ViewContainer {

  constructor(innerHTML) {
    super('ImeContainer', innerHTML);
    this._buttonID = '#IMEButton';
  }

  get actionButton() {
    return document.querySelector(this._buttonID);
  }

  init() {
    this.setEvent();
    this.setButtonPosition();
    this.show();
  }

  setEvent() {
    this.resizeEventContext = this.onResize.bind(this);
    this.clickEventContext = this.onClick.bind(this);

    this.actionButton.addEventListener('click', this.clickEventContext);
    this.actionButton.addEventListener('touchend', this.clickEventContext);
    window.addEventListener('resize', this.resizeEventContext);
  };

  onClick(event) {
    const scene = SceneManager._scene;
    if(scene instanceof Scene_Name) {
      scene._editWindow.back();
    }
  };

  onResize() {
    if(this.hidden) return;
    this.setButtonPosition();
  }

  setButtonPosition() {
    this.actionButton.style.marginLeft = ((window.innerWidth / 2) + ((window.innerWidth / 2) * 0.25)) + "px";
    this.actionButton.style.marginTop = ((window.innerHeight * 0.15)) + "px";
  }

  removeListeners() {
    this.actionButton.removeEventListener('click', this.clickEventContext);
    this.actionButton.removeEventListener('touchend', this.clickEventContext);
    window.removeEventListener('resize', this.resizeEventContext);
  }

  terminate() {
    this.hidden = true;
    this.removeListeners();
    this._terminateContainer();
  }
}

class ReturnButton extends ViewContainer {
  constructor(html) {
    super("ReturnContainer", html);
    this._buttonID = '#ReturnButton';
    this.setEvent();
    this.setButtonPosition();
  }

  get actionButton() {
    return document.querySelector(this._buttonID);
  }

  setEvent() {
    this.clickEventContext = this.onClick.bind(this);
    this.resizeEventContext = this.onResize.bind(this);

    this.actionButton.addEventListener('click', this.clickEventContext);
    this.actionButton.addEventListener('touchend', this.clickEventContext);
    window.addEventListener('resize', this.resizeEventContext);
  };

  onClick(event) {
    if(SceneManager._scene instanceof Scene_QuestLog && SceneManager._scene._itemWindow._index >= 0) {
      SceneManager._scene.onItemCancel();
      return;
    }

    if(SceneManager._stack.length === 0) {
      this.hide();
      if($gameSystem._gBtns[6] !== undefined) {
        Galv.SBTNS.removeButton(6);
      }
    }

    if(SceneManager._stack.length > 0) {
      SceneManager.pop();
      this.hide();
      if($gameSystem._gBtns[6] !== undefined) {
        Galv.SBTNS.removeButton(6);
      }
    }
  };

  onResize() {
    if(this.hidden) return;
    this.setButtonPosition();
  }

  setButtonPosition() {
    this.actionButton.style.marginLeft = (window.innerWidth - (window.innerWidth * 0.10)) + "px";
    this.actionButton.style.marginTop = (window.innerHeight * 0.01) + "px";
  }

  removeListeners() {
    this.actionButton.removeEventListener('click', this.clickEventContext);
    this.actionButton.removeEventListener('touchend', this.clickEventContext);
    window.removeEventListener('resize', this.resizeEventContext);
  }

  terminate() {
    this.hidden = true;
    this.removeListeners();
    this._terminateContainer();
  }
}

class CloseButton extends ViewContainer {
  constructor(html) {
    super("CloseContainer", html);
    this._buttonID = '#CloseButton';
    this.setEvent();
    this.setButtonPosition();
  }

  get actionButton() {
    return document.querySelector(this._buttonID);
  }

  setEvent() {
    this.clickEventContext = this.onClick.bind(this);
    this.resizeEventContext = this.onResize.bind(this);

    this.actionButton.addEventListener('click', this.clickEventContext);
    this.actionButton.addEventListener('touchend', this.clickEventContext);
    window.addEventListener('resize', this.resizeEventContext);
  };

  onClick() {
    if(SceneManager._stack.length === 0) {
      this.hide();
      if($gameSystem._gBtns[6] !== undefined) {
        Galv.SBTNS.removeButton(6);
      }
    }

    if(SceneManager._stack.length > 0) {
      SceneManager.pop();
      this.hide();
      if($gameSystem._gBtns[6] !== undefined) {
        Galv.SBTNS.removeButton(6);
      }
    }
  };

  onResize() {
    if(this.hidden) return;
    this.setButtonPosition();
  }

  setButtonPosition() {
    this.actionButton.style.marginLeft = (window.innerWidth - (window.innerWidth * 0.10)) + "px";
    this.actionButton.style.marginTop = (window.innerHeight * 0.01) + "px";
  }

  removeListeners() {
    this.actionButton.removeEventListener('click', this.clickEventContext);
    this.actionButton.removeEventListener('touchend', this.clickEventContext);
    window.removeEventListener('resize', this.resizeEventContext);
  }

  terminate() {
    this.hidden = true;
    this.removeListeners();
    this._terminateContainer();
  }
}

class ModalWindow extends ViewContainer {
  constructor(html) {
    super("ModalContainer", html);
    this._buttonID = '#CloseModal';
    this._modalID = '#ModalWindow';
    this._modalText = '#ModalText';
    this.setEvent();
    this.setModalPosition();
  }

  get actionButton() {
    return document.querySelector(this._buttonID);
  }

  get modalWindow() {
    return document.querySelector(this._modalID);
  }

  get modalText() {
    return document.querySelector(this._modalText).innerHTML;
  }

  set modalText(text) {
    document.querySelector(this._modalText).innerHTML = text;
  }

  setEvent() {
    this.clickEventContext = this.onClick.bind(this);
    this.resizeEventContext = this.onResize.bind(this);

    this.actionButton.addEventListener('click', this.clickEventContext);
    this.actionButton.addEventListener('touchend', this.clickEventContext);
    window.addEventListener('resize', this.resizeEventContext);
  };

  onClick() {
    this.hide();
    // if(SceneManager._stack.length === 0) {
    //     this.hide();
    // }
    //
    // if(SceneManager._stack.length > 0) {
    //     SceneManager.pop();
    //     this.hide();
    // }
  };

  onResize() {
    if(this.hidden) return;
    this.setModalPosition();
  }

  setModalPosition() {
    this.modalWindow.style.marginLeft = ((window.innerWidth / 2) - 50) + "px";
    this.modalWindow.style.marginTop = ((window.innerHeight / 2) - 50) + "px";
  }

  removeListeners() {
    this.actionButton.removeEventListener('click', this.clickEventContext);
    this.actionButton.removeEventListener('touchend', this.clickEventContext);
    window.removeEventListener('resize', this.resizeEventContext);
  }

  terminate() {
    this.hidden = true;
    this.removeListeners();
    this._terminateContainer();
  }
}

const innerHTML = `
        <div class="container-fluid">
            <button id="IMEButton" type="button" class="btn btn-danger" aria-label="Close">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-backspace-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M15.683 3a2 2 0 0 0-2-2h-7.08a2 2 0 0 0-1.519.698L.241 7.35a1 1 0 0 0 0 1.302l4.843 5.65A2 2 0 0 0 6.603 15h7.08a2 2 0 0 0 2-2V3zM5.829 5.854a.5.5 0 1 1 .707-.708l2.147 2.147 2.146-2.147a.5.5 0 1 1 .707.708L9.39 8l2.146 2.146a.5.5 0 0 1-.707.708L8.683 8.707l-2.147 2.147a.5.5 0 0 1-.707-.708L7.976 8 5.829 5.854z"/>
                </svg>
            </button>
        </div>`;

const returnHTML = `
        <div class="container-fluid">
            <button id="ReturnButton" type="button" class="btn btn-info">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-counterclockwise" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M12.83 6.706a5 5 0 0 0-7.103-3.16.5.5 0 1 1-.454-.892A6 6 0 1 1 2.545 5.5a.5.5 0 1 1 .91.417 5 5 0 1 0 9.375.789z"/>
                  <path fill-rule="evenodd" d="M7.854.146a.5.5 0 0 0-.708 0l-2.5 2.5a.5.5 0 0 0 0 .708l2.5 2.5a.5.5 0 1 0 .708-.708L5.707 3 7.854.854a.5.5 0 0 0 0-.708z"/>
                </svg>
            </button>
        </div>`;

const closeHTML = `
        <div class="container-fluid">
            <button id="CloseButton" type="button" class="btn btn-delete-img"></button>
        </div>`;

const modalHTML = `
        <div class="container-fluid">
            <div id="ModalWindow">
                <p id="ModalText">You have bought new item</p>
                <button id="CloseModal" type="button" class="btn btn-confirm">
                    Ok
                </button>
            </div>
        </div>`;

export const CustomView = {}
CustomView.imeDeleteButton = new IMEDeleteButton(innerHTML);
CustomView.returnButton = new ReturnButton(returnHTML);
CustomView.closeButton = new CloseButton(closeHTML);
CustomView.modalWindow = new ModalWindow(modalHTML);
